// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/styles.scss
// module id = 1986
// module chunks = 0